import React from 'react';
import { Box, Typography } from '@mui/material';
import PoolAnimationDisplay from './PoolAnimationDisplay';
import PoolChat from './PoolChat';

function EnterPool() {
  return (
    <Box
      sx={{
        backgroundColor: '#f2f0e4',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
      }}
    >
      <Typography variant={{ xs: 'h5', sm: 'h4', md: 'h3' }} component="h1" sx={{ color: '#000', fontWeight: 'bold' }}>
        Welcome to the Pool
      </Typography>
      <PoolAnimationDisplay />
      <PoolChat />
    </Box>
  );
}

export default EnterPool;
